module.exports = __webpack_public_path__ + "img/Data.ed598a52.svg";